import { create } from 'zustand';

import { api } from 'src/utils/axios';

import { MyInterestsRepository } from 'src/repositories/my-interests/my-interests.repository';

import {
  InterestOptions,
  myInterestsTypeItem,
  myInterestsResultTypeItem,
} from 'src/types/my-interests/my-interests';

type States = {
  isLoadingInterestsList: boolean;
  isLoadingSendMyInterests: boolean;
  isLoadingMyInterests: boolean;
  isLoadingReorderPreferences: boolean;
  isLoadingMaybeLater: boolean;
  myInterests: myInterestsTypeItem[];
  myInterestsResult: myInterestsResultTypeItem | null;
  useMyInterestsDialog: boolean;
  replyAgain: boolean;
};

type Actions = {
  getInterestsList: () => Promise<void>;
  sendMyInterests: (myInterests: InterestOptions[]) => Promise<void>;
  getMyInterests: () => Promise<void>;
  reorderPreferences: () => Promise<void>;
  setUseMyInterestsDialog: (value: boolean, replyAgain?: boolean) => void;
  maybeLater: () => Promise<void>;
};

type MyInterests = Actions & States;

const initialValues = {
  isLoadingInterestsList: false,
  isLoadingSendMyInterests: false,
  isLoadingMyInterests: true,
  isLoadingReorderPreferences: false,
  isLoadingMaybeLater: false,
  myInterests: [],
  myInterestsResult: null,
  useMyInterestsDialog: false,
  replyAgain: false,
};

const myInterestsRepository = new MyInterestsRepository(api);

export const useMyInterestsStore = create<MyInterests>((set: any, get: any) => ({
  ...initialValues,

  setUseMyInterestsDialog: (value: boolean, replyAgain?: boolean) => {
    set({ useMyInterestsDialog: value })
    set({ replyAgain })
  },

  getInterestsList: async () => {
    set({ isLoadingInterestsList: true });
    const response = await myInterestsRepository.getInterestsList();

    if (response.isLeft()) {
      set({ isLoadingInterestsList: false });
      throw new Error(response.value.message);
    } else {
      set({ myInterests: response.value, isLoadingInterestsList: false });
    }
  },

  sendMyInterests: async (myInterests: any[]) => {
    set({ isLoadingSendMyInterests: true });
    const response = await myInterestsRepository.sendMyInterests(myInterests);

    if (response.isLeft()) {
      set({ isLoadingSendMyInterests: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingSendMyInterests: false });
    }
  },

  getMyInterests: async () => {
    set({ isLoadingMyInterests: true });
    const response = await myInterestsRepository.getMyInterests();

    if (response.isLeft()) {
      set({ isLoadingMyInterests: false });
      throw new Error(response.value.message);
    } else {
      set({ myInterestsResult: response.value, isLoadingMyInterests: false });
    }
  },

  reorderPreferences: async () => {
    set({ isLoadingReorderPreferences: true });
    const response = await myInterestsRepository.reorderPreferences();

    if (response.isLeft()) {
      set({ isLoadingReorderPreferences: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingReorderPreferences: false });
    }
  },

  maybeLater: async () => {
    set({ isLoadingMaybeLater: true });
    const response = await myInterestsRepository.maybeLater();

    if (response.isLeft()) {
      set({ isLoadingMaybeLater: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingMaybeLater: false });
    }
  }
}));
